import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit {

  public pdfSource: string = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  pdf: any;

  constructor(
    private dialogRef: MatDialogRef<PdfViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    console.log("Data: ", this.data)
  }

  onLoadError = (_err: any) => {
    console.log("onLoadError: ", _err)
    const config: MatDialogConfig = {
      data: {msg: _err.message},
      scrollStrategy: new NoopScrollStrategy()
    };

    if (_err.status == 403) {
      this.data = "";
    }
    // const errorDialog = this.dialog.open(ErrorDialogComponent, config);

    // errorDialog.afterClosed().subscribe(()=>{
    //   this.dialogRef.close();
    // })
  }

}
